<figure>
  <img #imageRef [src]="currentSrc" [class]="customClass ? customClass : 'image'" class="hide-alt" [alt]="alt" [attr.loading]="lazy && !isInViewport ? 'lazy' : 'eager'" [width]="size" [height]="height" />
</figure>
